import { render } from "./innerpages.vue?vue&type=template&id=420ba28c"
import script from "./innerpages.vue?vue&type=script&lang=js"
export * from "./innerpages.vue?vue&type=script&lang=js"
script.render = render

export default script